import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ChakraProvider} from '@chakra-ui/react';
import {Provider} from 'react-redux';
import store from './app/store';
import './utils/fonts/LibreFranklin.ttf';
import {disableReactDevTools} from '@fvilers/disable-react-devtools';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import {ThemeProvider} from '@mui/material/styles';
import {createTheme} from '@mui/material/styles';


if (process.env.NODE_ENV === 'production') {
    disableReactDevTools();
}
const theme = createTheme({
    // theme
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider theme={theme}>
        <ChakraProvider>
            <Provider store={store}>
                <App/>
            </Provider>
        </ChakraProvider>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
